get $__placeholder__0() { return $__placeholder__1; }


/** WEBPACK FOOTER **
 ** ../../@traceur/generated/TemplateParser/1
 **/